import React from 'react'
import EntryMarker from 'marketing-site/src/components/common/EntryMarker'

import { IProps as IStatistics, Statistics } from 'marketing-site/src/library/components/Statistics'
import { IStatistics as IContentfulStatistics } from 'marketing-site/@types/generated/contentful'
import * as Utils from 'marketing-site/src/library/utils'
import { transformStat } from 'marketing-site/src/transformers/elements/ContentfulStatistic'

export const ContentfulStatistics = (data: IContentfulStatistics) => (
  <EntryMarker entry={data}>{() => <Statistics {...transformStatistics(data)} />}</EntryMarker>
)

export const getSnakeCaseFromString = (string: string) => string.replace(/\s+/g, '-').toLowerCase()

export function transformStatistics({ fields }: IContentfulStatistics): IStatistics {
  return {
    ...fields,
    variation: fields.variation && getSnakeCaseFromString(fields.variation),
    statistics: fields.statistics.map(transformStat),
    backgroundColor: Utils.getHexColorFromName(fields.backgroundColor),
  }
}
